import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import WhatWeBelieve from "./pages/WhatWeBelieve";
import Videos from "./pages/Videos";
import MinistryPage from "./pages/MinistryPage";
import StaffPage from "./pages/StaffPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import AdminDashboard from "./auth/AdminDashboard";
import ScrollToTop from "./components/ScrollToTop";

function PublicChrome({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/LW155" element={<AdminDashboard />} />
          <Route path="/" element={<PublicChrome><Home /></PublicChrome>} />
          <Route path="/what-we-believe" element={<PublicChrome><WhatWeBelieve /></PublicChrome>} />
          <Route path="/videos" element={<PublicChrome><Videos /></PublicChrome>} />
          <Route path="/ministries/:slug" element={<PublicChrome><MinistryPage /></PublicChrome>} />
          <Route path="/staff" element={<PublicChrome><StaffPage /></PublicChrome>} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
